import {
  BriefcaseIcon,
  CertificateIcon,
  CheckCircleIcon,
  FolderOpenIcon,
  GraduationCapIcon,
  HandHeartIcon,
  HeartIcon,
  IdentificationBadgeIcon,
  MedalIcon,
  NewspaperClippingIcon,
  PlusIcon,
  QuotesIcon,
  TranslateIcon,
  UserCircleIcon,
  WrenchIcon,
} from "@phosphor-icons/react";

import { STEP_LABELS, type BuilderStep } from "@/client/constants/builder-steps";

const ICONS: Record<string, typeof UserCircleIcon> = {
  basics: UserCircleIcon,
  experience: BriefcaseIcon,
  education: GraduationCapIcon,
  skills: WrenchIcon,
  summary: IdentificationBadgeIcon,
  languages: TranslateIcon,
  projects: FolderOpenIcon,
  certifications: CertificateIcon,
  volunteer: HandHeartIcon,
  awards: MedalIcon,
  interests: HeartIcon,
  publications: NewspaperClippingIcon,
  references: QuotesIcon,
  finalization: CheckCircleIcon,
};

export const getSidebarItem = (step: BuilderStep, customName?: string) => ({
  id: step,
  label: customName ?? STEP_LABELS[step] ?? "Section personnalisée",
  icon: ICONS[step] ?? PlusIcon,
});
